import { useEffect, useState } from 'react';

/** Telefon i wąskie okna: poniżej tego progu sidebar jest wysuwanym panelem (dziś breakpoint `lg` to 1024, tu 900 wg makiety). */
export const MOBILE_QUERY = '(max-width: 899px)';

const matches = (query: string): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;

export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const onChange = () => setValue(list.matches);
    onChange();
    list.addEventListener('change', onChange);

    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return value;
}

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
